<template>
  <div 
    class="notification toast-item p-2"
    :class="toastService.getBulmaClass(toast.type)"
    @mouseenter="pause"
    @mouseleave="resume"
  >
    <div class="is-flex is-align-items-center is-justify-content-space-between">
      <span class="icon-text">
          <span class="icon mr-2">
            <FontAwesomeIcon :icon="toast.icon" />
          </span>
          <span>{{ toast.message }}</span>
      </span>
      <button class="delete" @click="close"></button>
    </div>
  </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { toastService } from '../utils/toastService.js';

const props = defineProps({
  toast: {
    type: Object,
    required: true
  }
});

const close = () => {
  toastService.remove(props.toast.id);
};

const pause = () => {
  toastService.pause(props.toast.id);
};

const resume = () => {
  toastService.resume(props.toast.id);
};
</script>

<style scoped>
.toast-item {
  margin-bottom: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: default;
}

.toast-item:hover {
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}
</style>